"use strict";var C=Object.create;var a=Object.defineProperty;var N=Object.getOwnPropertyDescriptor;var k=Object.getOwnPropertyNames;var v=Object.getPrototypeOf,E=Object.prototype.hasOwnProperty;var g=(e,r)=>a(e,"name",{value:r,configurable:!0});var $=(e,r)=>{for(var o in r)a(e,o,{get:r[o],enumerable:!0})},y=(e,r,o,l)=>{if(r&&typeof r=="object"||typeof r=="function")for(let s of k(r))!E.call(e,s)&&s!==o&&a(e,s,{get:()=>r[s],enumerable:!(l=N(r,s))||l.enumerable});return e};var m=(e,r,o)=>(o=e!=null?C(v(e)):{},y(r||!e||!e.__esModule?a(o,"default",{value:e,enumerable:!0}):o,e)),S=e=>y(a({},"__esModule",{value:!0}),e);var _={};$(_,{default:()=>b});module.exports=S(_);var i=m(require("next/router")),n=m(require("nprogress")),t=m(require("prop-types")),f=m(require("react"));function b({color:e="#29D",startPosition:r=.3,stopDelayMs:o=200,height:l=3,showOnShallow:s=!0,options:d,nonce:T}){let p=null;f.useEffect(()=>(d&&n.configure(d),i.default.events.on("routeChangeStart",h),i.default.events.on("routeChangeComplete",x),i.default.events.on("routeChangeError",c),()=>{i.default.events.off("routeChangeStart",h),i.default.events.off("routeChangeComplete",x),i.default.events.off("routeChangeError",c)}),[]);let h=g((P,{shallow:u})=>{(!u||s)&&(n.set(r),n.start())},"routeChangeStart"),x=g((P,{shallow:u})=>{(!u||s)&&(p&&clearTimeout(p),p=setTimeout(()=>{n.done(!0)},o))},"routeChangeEnd"),c=g((P,u,{shallow:w})=>{(!w||s)&&(p&&clearTimeout(p),p=setTimeout(()=>{n.done(!0)},o))},"routeChangeError");return f.createElement("style",{nonce:T},`
      #nprogress {
        pointer-events: none;
      }
      #nprogress .bar {
        background: ${e};
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100%;
        height: ${l}px;
      }
      #nprogress .peg {
        display: block;
        position: absolute;
        right: 0px;
        width: 100px;
        height: 100%;
        box-shadow: 0 0 10px ${e}, 0 0 5px ${e};
        opacity: 1;
        -webkit-transform: rotate(3deg) translate(0px, -4px);
        -ms-transform: rotate(3deg) translate(0px, -4px);
        transform: rotate(3deg) translate(0px, -4px);
      }
      #nprogress .spinner {
        display: block;
        position: fixed;
        z-index: 1031;
        top: 15px;
        right: 15px;
      }
      #nprogress .spinner-icon {
        width: 18px;
        height: 18px;
        box-sizing: border-box;
        border: solid 2px transparent;
        border-top-color: ${e};
        border-left-color: ${e};
        border-radius: 50%;
        -webkit-animation: nprogresss-spinner 400ms linear infinite;
        animation: nprogress-spinner 400ms linear infinite;
      }
      .nprogress-custom-parent {
        overflow: hidden;
        position: relative;
      }
      .nprogress-custom-parent #nprogress .spinner,
      .nprogress-custom-parent #nprogress .bar {
        position: absolute;
      }
      @-webkit-keyframes nprogress-spinner {
        0% {
          -webkit-transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
        }
      }
      @keyframes nprogress-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `)}g(b,"NextNProgress");b.propTypes={color:t.string,startPosition:t.number,stopDelayMs:t.number,height:t.number,showOnShallow:t.bool,options:t.object,nonce:t.string};0&&(module.exports={});
//# sourceMappingURL=index.js.map